import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";

import Axios from "./helpers/Axios";

import NProgress from "nprogress";
import "nprogress/nprogress.css";
Vue.use(NProgress);
import "quill/dist/quill.snow.css";
// import ECharts from 'vue-echarts';
// import ECharts from 'vue-echarts';
// import ECharts from 'vue-echarts/components/ECharts.vue';
// import 'echarts/lib/chart/line';
// Vue.component('chart', ECharts);
// import echarts from 'echarts';
// Vue.prototype.$echarts = echarts;

// Vue.component('v-chart', ECharts);

import "animate.css";

import iView from "iview";
import "iview/dist/styles/iview.css";
import "./assets/style/reset.less";
import "./assets/style/trend-common.less";
import "./assets/style/common.less";

Vue.use(iView);
Vue.config.productionTip = false;

import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require("./assets/img/zwt.png"),
  loading: require("./assets/img/zwt.png"),
  attempt: 1
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach(transition => {
  NProgress.done();
  NProgress.remove();
});

Vue.prototype.$http = Axios;

new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js